'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (msg, opts) {
  for (var key in opts) {
    if (typeof opts[key] === 'string') {
      opts[key] = _I18n2.default.SafeString(opts[key]);
    }
  }
  return _I18n2.default.text(msg, opts);
};

module.exports = exports['default'];